var _line, _line2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.6,
    y1: 4.06125,
    x2: 17.4,
    y2: 4.06125,
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.6,
    y1: 9.06125,
    x2: 17.4,
    y2: 9.06125,
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.06131C9 3.72798 14 4.6613 14 9.16127C14 13.7634 8.79083 14.137 5.86419 13.7192C5.76312 13.7048 5.7047 13.8345 5.78265 13.9004L12 19.1613",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.d614b8faad1c78925840c37e984b1668.svg";
export { ForwardRef as ReactComponent };